module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-545.687ae1a.woff2";